var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF6363"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 16.5226V20.7979M19.8335 25.0733H19.846M18.0058 11.029L8.95296 26.1421C8.76631 26.4653 8.66756 26.8318 8.66651 27.205C8.66546 27.5783 8.76218 27.9453 8.94701 28.2696C9.13185 28.5938 9.39836 28.8641 9.72006 29.0533C10.0418 29.2426 10.4074 29.3444 10.7806 29.3484H28.8863C29.2597 29.3444 29.6252 29.2426 29.947 29.0533C30.2687 28.8641 30.5352 28.5938 30.72 28.2696C30.9048 27.9453 31.0015 27.5783 31.0005 27.205C30.9995 26.8318 30.9007 26.4653 30.714 26.1421L21.6612 11.029C21.4706 10.7149 21.2023 10.4552 20.8822 10.2749C20.5621 10.0947 20.2009 10 19.8335 10C19.4661 10 19.1049 10.0947 18.7848 10.2749C18.4646 10.4552 18.1964 10.7149 18.0058 11.029Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9b2ce19db046c24c1dfeeb86d06d35db.svg";
export { ForwardRef as ReactComponent };